import bugsnag from 'bugsnag-js';
import createPlugin from 'bugsnag-react';
import React from 'react';

const { BUGSNAG_KEY } = process.env;
const { DEFAULTLOCALE } = process.env;
const { DEPLOYMENT_ENV } = process.env;
const { APP_VERSION } = process.env;

const bugsnagClient =
  process.env.BROWSER && BUGSNAG_KEY
    ? bugsnag({
        apiKey: BUGSNAG_KEY,
        appVersion: APP_VERSION,
        notifyReleaseStages: ['stag', 'prod'],
        releaseStage: DEPLOYMENT_ENV,
        metaData: {
          locale: DEFAULTLOCALE,
        },
      })
    : null;

const BugsnagErrorBoundary = bugsnagClient
  ? bugsnagClient.use(createPlugin(React))
  : React.Fragment;

export default BugsnagErrorBoundary;



// WEBPACK FOOTER //
// ./src/components/BugsnagErrorBoundary/BugsnagErrorBoundary.js